<template>
  <Modal
    :title="title"
    :closable="false"
    v-model="modalShowHide"
    @on-visible-change="onVisibleChange"
    :width="width"
    class="modal-setting"
    footer-hide
    class-name="vertical-center-modal"
  >
    <!--    <div class="w-full bg-cc h-40 bold fs-14 flex j-center a-center m-b-10">{{title}}</div>-->

    <div>
      <div class="flex">
        <div class="m-r-100">
          <Input style="width: 300px" clearable
                 v-model="publishObj.name" placeholder="输入用户姓名">
            <template #append>
              <Button @click="onCustomerChooseClick" icon="md-add"
                      style="width: 50px"></Button>
            </template>
          </Input>
          <div></div>
          <DatePicker
            :value="publishObj.publishTime"
            class="m-v-30" format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期和时间"
            style="width: 300px"></DatePicker>
        </div>
        <up-load-image @uploadSuccess="uploadImageSuccess" picurl="common/logo/">
          <div slot="tip">
            <div class="m-l-10">
              <div class="flex-column a-center j-center border"
                   style="width: 100px; height: 100px;background: #EDEDED;border-radius: 50%"
                   v-if="!publishObj.logo">
                <img alt="" key="789" src="../../../../assets/common/ic_upload_c.png"
                     style="width: 36px;height: 32px;">
                <span class="d-block m-t-5 fs-14" style="color:#999999">上传图片</span>
              </div>
              <div class="relative top-0 left-0" style="width: 100px; height: 100px;"
                   v-if="publishObj.logo">
                <img :src="publishObj.logo" alt="" class="w-full h-full" key="123"
                     style="border-radius: 50%">
                <img @click.stop="onImgDelClick" class="w-24 h-24 p-3 absolute right--12 top--12"
                     key="456"
                     src="../../../../assets/common/ic_shanchu_red_sub.png">
              </div>
            </div>
          </div>
        </up-load-image>
      </div>
      <div>
        <Input type="textarea" v-model="content" rows="4"/>
      </div>
      <div class="w-full flex j-center p-v-10" slot="footer">
        <Button @click="cancel()" style="width: 100px">取消</Button>
        <Button @click="ok()" style="margin-left: 50px;width: 100px" type="primary">确定</Button>
      </div>

    </div>

    <Modal :closable="false"
           :mask-closable="false"
           @on-visible-change="onServiceChooseModalClose"
           class="prewmodal"
           class-name="vertical-center-modal"
           footer-hide
           v-model="showServicechoose"
           width="900">
      <service-choose-widget :open="showServicechoose" @cancel="showServicechoose=false"
                             @ok="onServicesPersonSave"></service-choose-widget>
    </Modal>


  </Modal>
</template>

<script>
import {mapActions} from 'vuex'
import UpLoadImage from '../../../../components/common/UpLoadImage'
import ServiceChooseWidget from '@/views/material/example/components/ServiceChooseWidget'
import {formatTimeStamp} from '@/utils/dateUtil'


export default {
  name: 'AddCommentWidget',
  components: {ServiceChooseWidget, UpLoadImage},
  props: {
    //标题
    title: {
      type: String,
      default: '发布评论',
    },
    // 宽度
    width: {
      type: Number,
      default: 600,
    },
  },
  watch:{
    'publishObj.name':{
      handler(newValue){
        this.publishObj.id=0
      }
    }
  },
  data () {
    return {
      modalShowHide: false,
      //选择客服
      showServicechoose: false,
      title: '',
      name: '',
      icon: '',
      publishTime: '2022:12:12 09:12:12',
      content: '',
      publishObj: {
        id: 0,
        name: '',
        logo: '',
        publishTime: this.getCurrentTimeString()
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    uploadImageSuccess (data) {
      if (data && data.length) {
        this.icon = data[0].url
      }
    },
    onImgDelClick () {
      this.publishObj.logo = ''
    },
    show () {
      this.modalShowHide = true
    },
    hide () {
      this.modalShowHide = false
    },

    onVisibleChange (show) {
      if (show) {
        this.publishObj.publishTime = this.getCurrentTimeString()
      } else {

      }
    },

    ok () {

      this.show()
    },
    cancel () {

      this.hide()
    },

    getCurrentTimeString () {
      return formatTimeStamp(new Date())
    },

    ////////////////////选择客服/////////////////////////
    onCustomerChooseClick () {
      this.showServicechoose = true
    },
    onServiceChooseModalClose (status) {
      if (!status) {

      }
    },
    onServicesPersonSave (data) {
      if (data && data.length) {
        let info = data[0]
        this.publishObj = {
          ...this.publishObj,
          id: info.id,
          name: info.name || '',
          logo: info.logo,
        }
      }
      this.showServicechoose = false
    },
    ////////////////////选择客服/////////////////////////

    ...mapActions([
      'addAdminUser',
      'getAdminInfo',
      'editAdminInfo',
      'addCustomerServiceUser'
    ])
  }
}
</script>

<style lang="scss" scoped>
.modal-setting ::v-deep {
  .ivu-modal-header {
    background-color: #EEEEEE;
    margin-bottom: 15px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    max-height: 45px;
  }

  .ivu-modal-header-inner {
    display: flex;
    justify-content: center;
  }

  .ivu-modal-body {
    padding: 0;
    display: flex;
    justify-content: center;
    align-content: center;
  }

  //标题下横线
  .ivu-modal-header {
    border-bottom: none;
  }

  //确认取消按钮上面红线
  .ivu-modal-footer {
    border-top: none;
  }
}
</style>
